<script>
import app from '../web_feathers.js';

const {perms, email, userID, checkedToken,checkingToken} = app;

import Router from 'svelte-spa-router';
import { link, location, pop, push} from 'svelte-spa-router';
import active from 'svelte-spa-router/active';

import Fa from 'svelte-fa'
import { faHome,faSearch } from '@fortawesome/free-solid-svg-icons';

import passwordNew from '../new_password/passwordNew.svelte';
import passwordSet from '../new_password/passwordSet.svelte';
import Login from './login.svelte';
import Main from './main.svelte';
import Line from './line.svelte';
import UpdateCreditCard from './updateCreditCard.svelte';


const routes = {
    // Exact path
   // '/': , //TODO: make a home dashboard

    // Using named parameters, with last being optional

	'/new_password/:email/:resetToken': passwordSet,
	'/new_password/:information': passwordNew,
	'/new_password': passwordNew,
	'/line/:lineID': Line,
	'/search/:search': Main,
	'/update_credit_card/:lineID': UpdateCreditCard,


    // Catch-all
    // This is optional, but if present it must be the last
    '*': Main,
}

let searchTerm='';
if($location.includes('/search/')) searchTerm = decodeURIComponent($location.replace('/search/',''));
function search(event){
	if (event.keyCode !== 13) return;//only listen for enter
	if (!searchTerm) return;
	
	event.preventDefault();
	push('/search/'+searchTerm.trim());
	}
function doSearch(){
	if (!searchTerm) return;
	push('/search/'+searchTerm.trim());
	}
</script>

<style>
/* Style for "active" links; need to mark this :global because the router adds the class directly */
:global(a.active) {
	font-weight: bold;
	}

.ribbon {
  background-color: #a00;
  overflow: hidden;
  white-space: nowrap;
  /* top left corner */
  position: fixed;
  right: -60px;
  top: 60px;
  /* 45 deg ccw rotation */
  -webkit-transform: rotate(45deg);
     -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
       -o-transform: rotate(45deg);
          transform: rotate(45deg);
  /* shadow */
  -webkit-box-shadow: 0 0 10px #888;
     -moz-box-shadow: 0 0 10px #888;
          box-shadow: 0 0 10px #888;
  }
.ribbon a {
  border: 1px solid #faa;
  color: #fff;
  display: block;
  font: bold 100% 'Helvetica Neue', Helvetica, Arial, sans-serif;
  margin: 1px 0;
  padding: 10px 100px;
  text-align: center;
  text-decoration: none;
  /* shadow */
  text-shadow: 0 0 5px #444;
  }
</style>


<main>
<br>
{#if process.env.NODE_ENV=='test'}
	<div class="ribbon">
		<a href="#">Test site!</a>
	</div>
{/if}



{#await checkingToken}
	... checking if you're logged in ... 
{:then}

{#if $location.includes('new_password')} <!-- routes for not logged in-->
<div class="m-1">
	<Router {routes} on:routeLoading={console.log}/>
	</div>
{:else if $userID}
	<div class="float-right">
		{#if $perms && $perms=='admin'}
			<input type="text" placeholder="Search" bind:value={searchTerm} on:keyup={search}><span on:click={doSearch}>&nbsp;<Fa icon={faSearch}/></span>&nbsp;&nbsp;
		{/if}


		{#if $location.includes('line/') || $location.includes('update_credit_card/')}
			<a use:link href="/" class="btn btn-sm btn-primary"><Fa icon={faHome}/> Main Page</a>&nbsp;&nbsp;
			{#if $perms && $perms=='admin'}
				<a href="admin.html#/SimActivations/{$location.split('/').pop()}" class="btn btn-sm btn-primary">View in Admin Panel</a>&nbsp;&nbsp;
			{/if}
		{/if}
		<button on:click={app.logoutFull} class="btn btn-sm btn-warning">Logout</button>
	</div>
	<br><br>

	<div class="m-1">
	<Router {routes} on:routeLoading={console.log}/>
	</div>

{:else}
	<Login />
		
{/if}
{/await}


</main>
